import { render } from "./VideoContent.vue?vue&type=template&id=1257f59c&scoped=true"
import script from "./VideoContent.vue?vue&type=script&lang=js"
export * from "./VideoContent.vue?vue&type=script&lang=js"

import "./VideoContent.vue?vue&type=style&index=0&id=1257f59c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1257f59c"]])

export default __exports__